import React, { useState, useEffect } from 'react'
import './ResetPassword.scss'
import axios from 'axios'
import * as _ from 'lodash'
import { UserIconLogin } from '../utils/icons';
import { DobleGuion } from '../components/DobleGuion'
import { comprobarDatos } from '../hooks/validateForm';
import { connect } from 'react-redux'
import { showPopup } from '../actions'
import { API } from '../hooks/config'

const ResetPassword = (props) => {
    const { clickChangeRegistrationLogin } = props
    const [email, setEmail] = useState('')

    const reglas = {
        email: {
            presence: { allowEmpty: false, message: 'es un campo obligatorio' },
            email: { message: 'con un formato invalido' },
        }
    };

    const handleClickAccess = () => {
        comprobarDatos({ email: email }, reglas).then(res => {
            const headers = {
                headers: {
                    'Content-Type': 'application/json',
                }
            };
            axios.post(`${API}/reset-user-password`, { email: email }, headers).then(async res => {
                props.showPopup({ active: true, message: 'Se ha enviado un email con la nueva contraseña', type: 'success' })
            }).catch(err => {
                props.showPopup({ active: true, message: 'Error al recuperar acceso', type: 'error' })
            });
        }).catch(err => {
            props.showPopup({ active: true, message: err, type: 'error' })
        })
    }

    return (
        <div className="reset-password-component-container">
            <div className="header">
                <div className="data">
                    <p>Recuperar contraseña</p>
                    <DobleGuion />
                </div>
            </div>
            <div className="reset-password-component-content">
                <div className="form-reset-password">
                    <div className="input-block email">
                        <label htmlFor="email">Email</label>
                        <div className="input">
                            <input type="text" onChange={event => setEmail(event.target.value)} value={email} />
                            <UserIconLogin size={20} />
                        </div>
                    </div>
                </div>
                <div className="buttons">
                    <button className="btn btn-invert" onClick={handleClickAccess}>Enviar</button>
                </div>
                <div className="go-registration">
                    <p>¿Ya eres usuario?</p>
                    <a className="pointer" onClick={() => clickChangeRegistrationLogin('login')}>Accede ahora</a>
                </div>
            </div>
        </div>
    )
}

const mapDispatchToProps = {
    showPopup
}

export default connect(null, mapDispatchToProps)(ResetPassword)

